export const newBundle = 'We’ve updated the site since your last visit.';
export const oops = 'Oops, something went wrong...';
export const pageRefresh = 'Please refresh the page.';
export const tryAgain = "Let's try again";
